// src/components/AdminPublicRoute.jsx
import { Navigate } from "react-router-dom";

const AdminPublicRoute = ({ children }) => {
  const adminToken = localStorage.getItem("adminToken");

  if (adminToken) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return children;
};

export default AdminPublicRoute;